<div class="prs-auth-modal-panel" data-testing-id="demo-sso-modal">
  <div class="modal-header">
    <h2 class="modal-title" id="prs-auth-modal-demo-sso-title">
      {{ 'account.login.sso.microsoft.demo.title' | translate }}
    </h2>
    <button
      type="button"
      class="btn-close"
      [attr.title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <p class="text-muted mb-3">{{ 'account.login.sso.microsoft.demo.hint' | translate }}</p>

    <div class="prs-auth-demo-picker" role="list">
      @for (identity of identities; track identity.id) {
      <button
        type="button"
        class="prs-auth-demo__fill"
        role="listitem"
        (click)="select(identity)"
        [attr.aria-label]="identity.fillAriaKey | translate"
        [attr.data-testing-id]="'demo-sso-' + identity.id"
      >
        <span class="prs-auth-demo__fill-label" aria-hidden="true">{{ identity.labelKey | translate }}</span>
        <span class="prs-auth-demo__fill-creds" aria-hidden="true">
          <code>{{ identity.email }}</code>
        </span>
        <span class="prs-auth-demo__fill-outcome text-muted" aria-hidden="true">{{
          identity.outcomeKey | translate
        }}</span>
      </button>
      }
    </div>
  </div>
</div>
